import { render, staticRenderFns } from "./fullscreen.vue?vue&type=template&id=39e1f23c&scoped=true&"
var script = {}
import style0 from "./fullscreen.vue?vue&type=style&index=0&id=39e1f23c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e1f23c",
  null
  
)

export default component.exports